import { client } from '@/common-utils/libraries/axios/axios';
import CUSTOMIZATION from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdateCustomization = (onSuccess, onError) => {
    return {
        mutationFn: (packageCustomizationData) => {
            return client.put(replaceParameters(CUSTOMIZATION.UPDATE_PACKAGE_CUSTOMIZATION.url, { uuid: packageCustomizationData?.uuid }), packageCustomizationData);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdateCustomization;